
import { Component, Vue, Prop } from "vue-property-decorator";
import { productList, getDevice } from "@/api/device";
import { UserModule } from "@/store/modules/user";
import { addDevice } from "@/api/order";

@Component({
  name: "device",
})
export default class extends Vue {
  // 接受父组件的值
  @Prop({
    type: Array,
    default: () => [],
  })
  selectDevice!: any;

  @Prop({
    type: String,
    default: "",
  })
  companyId!: string;
  // 1 报修 2 添加 3 订单处理 4 任务处理 5 巡检 6 一次巡检 7 安装单 8 巡检搜索 9自定义报表搜索
  @Prop({
    type: Number,
    default: 0,
    required: true,
  })
  enterType!: Number;

  @Prop({
    type: Boolean,
    default: false,
  })
  deviceVisible!: Boolean;

  @Prop({
    type: Object,
    default: () => ({}),
  })
  orderDetail!: any;
  @Prop({
    type: Object,
    default: () => ({}),
  })
  customer!: any;

  private brandList: any = {};
  private productList: any = {};
  private moduleList: any = {};
  private form: any = {};
  private isShowCustomer = false;

  private isLoadMore = false;
  private tableData: any = [];
  private currentPage: number = 1;

  private selectedDevice: any = [];
  private selectedDeviceId: any = [];
  private selectedDeviceRadioId:string='';
  private key: any = [];

  created() {
    // switch (this.enterType) {
    //   case 2:
    //   case 7:
    this.form.customer = this.customer;
    this.isShowCustomer = true;
    //     break;
    // }
    this.getBrand("", 1);
    this.getDeviceList();
  }
  private search() {
    this.getDeviceList();
  }
  private reset() {
    this.form = {
      brand: {},
      product: {},
      model: {},
      customer: {},
    };
    this.productList = [];
    this.moduleList = [];
    this.currentPage = 1;
    this.getDeviceList();
  }
  private getDeviceList() {
    const params: any = {
      company_id: this.companyId ? this.companyId : UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      page: this.currentPage,
      size: 10,
    };

    if (this.form.number) {
      params.number = this.form.number;
    }

    if (this.form.sn) {
      params.sn = this.form.sn;
    }
    if (this.form.brand && this.form.brand.id) {
      params.brand_id = this.form.brand.id;
    }
    if (this.form.product && this.form.product.id) {
      params.product_id = this.form.product.id;
    }
    if (this.form.model && this.form.model.id) {
      params.model_id = this.form.model.id;
    }
    if (this.form.customer && this.form.customer.customer_type) {
      if (parseInt(this.form.customer.customer_type) === 1) {
        params.customer_company_id = this.form.customer.customer_company_id;
      } else {
        params.customer_user_id = this.form.customer.customer_user_id;
      }
    }
    if (this.form.name) {
      params.device_name = this.form.name;
    }
    switch (this.enterType) {
      case 1:
      case 2:
        params.company_id = UserModule.getCompanyId;

        if (
          this.companyId &&
          parseInt(this.companyId) !== 0 &&
          parseInt(UserModule.getCompanyId) !== 0 &&
          UserModule.company &&
          parseInt(String(UserModule.company.vip_level).substring(0, 1)) !== 2
        ) {
          params.servicer_company_id = this.companyId;
        }
        params.auth_my = 1;
        break;
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
        break;
    }
    getDevice(params)
      .then((res) => {
        if (res && res.data) {
          if (res.data.page_count > res.data.page_current) {
            this.isLoadMore = true;
          } else {
            this.isLoadMore = false;
          }
          if (this.currentPage === 1) {
            this.tableData = res.data.list;
          } else {
            this.tableData = this.tableData.concat(res.data.list);
          }
        } else {
          this.isLoadMore = false;
          this.tableData = [];
        }
      })
      .catch((err) => {
        this.isLoadMore = false;
        this.tableData = [];
        let msg = err.msg;
      });
  }
  private loadMore() {
    this.currentPage = this.currentPage + 1;
    this.getDeviceList();
  }
  private getBrand(id: string, type: number) {
    let parameters: any = {};
    parameters.company_id = this.companyId
      ? this.companyId
      : UserModule.getCompanyId;
    parameters.product_type = type;
    switch (type) {
      case 1:
        break;
      case 2:
        parameters.brand_id = id;
        break;
      case 3:
        parameters.brand_id = this.form.brand.id;
        parameters.product_id = id;
        break;
    }

    productList(parameters)
      .then((res) => {
        switch (type) {
          case 1:
            if (res.data) {
              this.brandList = res.data.list;
            } else {
              this.brandList = [];
            }

            break;
          case 2:
            if (res.data) {
              this.productList = res.data.list;
            } else {
              this.productList = [];
            }

            break;
          case 3:
            if (res.data) {
              this.moduleList = res.data.list;
            } else {
              this.moduleList = [];
            }

            break;
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }
  private brandChange(val: any) {
    this.form.product = {};
    this.form.model = {};
    if (val && val.id) {
      this.getBrand(val.id, 2);
    } else {
      this.productList = [];
    }
  }
  private productChange(val: any) {
    this.form.model = {};
    if (val && val.id) {
      this.getBrand(val.id, 3);
    } else {
      this.moduleList = [];
    }
  }
  private moduleChange(val: any) {
    this.getBrand(this.form.product.id, 3);
  }

  
  private radioChange(val:any){
    this.selectedDevice=val
  }
  private handleSelectionChange(checked: boolean, val: any) {
    let index = this.selectedDevice.findIndex((ss: any) => {
      return ss.id === val.id;
    });
    if (checked) {
      if (index === -1) {
        this.selectedDevice.push(val);
      }
    } else {
      if (index !== -1) {
        this.selectedDevice.splice(index, 1);
      }
    }
  }
  private handleDialogConfirm() {
    if (this.selectedDevice.length === 0) {
      this.showErrorMsg("请选择设备");
      return;
    }
    switch (this.enterType) {
      case 1:
      case 2:
      case 5:
      case 6:
      case 8:
      case 9:
        this.selectedDevice.address = this.selectedDevice.device_address;
        this.$emit("confirm", this.selectedDevice);
        this.$emit("close", false);
        break;
      case 7:
        if (this.selectDevice.length + this.selectedDevice.length > 5) {
          this.showErrorMsg("最多只能选择5个设备");
          return;
        }
        this.$emit("confirm", this.selectedDevice);
        this.$emit("close", false);
        break;
      case 3:
        this.addDevices();
        break;
      case 4:
        this.addDevices();
        break;
    }
  }
  private close() {
    this.$emit("close", false);
  }

  // 东改 添加设备 request
  private addDevices() {
    let devices: any = [];
    for (const item of this.selectedDevice) {
      let device: any = {};
      device.device_id = item.id;
      devices.push(device);
    }
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId ? this.companyId : UserModule.getCompanyId,
      order_id: this.orderDetail.order.id,
      device: JSON.stringify(devices),
    };
    params.source_type = 2;
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addDevice(params)
      .then((res: any) => {
        this.$emit("confirm", this.selectedDevice);
        this.$emit("close", false);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
}
